import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Посмотреть резюме и связаться со мной можете на `}<a href="https://tomsk.hh.ru/resume/c58a5ea4ff08426f920039ed1f39765867794e">{` hh.ru `}</a></h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      